import { ComponentType } from 'react';
import { TestsList } from './tests-list/tests-list';

export const Tests: ComponentType = () => <TestsList />;
